import { Input } from '@/components/ui/input';
import { descriptionChanged } from '@/providers/AdminEngagementProvider/actions';
import { useAdminEngagementContext } from '@/providers/AdminEngagementProvider/AdminEngagementContext';

export function DescriptionInput() {
  const {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    state: { editorMode, ...engagement },
    dispatch,
  } = useAdminEngagementContext();

  return (
    <Input
      id="description"
      value={engagement.description || ''}
      onChange={(e) =>
        dispatch(
          descriptionChanged({
            description: e.target.value,
          }),
        )
      }
      className="text-foreground"
    />
  );
}
